
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"7.41"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Icon material-keyboard-arrow-down","d":"M1.41 0L6 4.58 10.59 0 12 1.41l-6 6-6-6z","fill":"#adadad"}})])
          )
        }
      }
    